import { render, staticRenderFns } from "./TextTag.vue?vue&type=template&id=4068a6a3&scoped=true"
import script from "./TextTag.vue?vue&type=script&lang=js"
export * from "./TextTag.vue?vue&type=script&lang=js"
import style0 from "./TextTag.vue?vue&type=style&index=0&id=4068a6a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068a6a3",
  null
  
)

export default component.exports